import { useState } from "react";
import { Link } from "react-router-dom";

// ── PRICING DATA ────────────────────────────────────────────────────
const TIERS = [
  { u: "1–10",  label: "1–10 units",  listing: 700,  pricing: 850,  ld: "5–7 business days",  pd: "3–5 business days",  bd: "7–10 business days" },
  { u: "11–20", label: "11–20 units", listing: 1500, pricing: 1900, ld: "6–8 business days",  pd: "4–6 business days",  bd: "8–12 business days",  popular: true },
  { u: "21–35", label: "21–35 units", listing: 2870, pricing: 3400, ld: "8–10 business days", pd: "5–7 business days",  bd: "10–14 business days" },
  { u: "36–49", label: "36–49 units", listing: 4300, pricing: 5200, ld: "10–12 business days",pd: "7–9 business days",  bd: "12–16 business days" },
  { u: "50+",   label: "50+ units",   listing: 6500, pricing: 7600, ld: "12–15 business days",pd: "9–12 business days", bd: "14–18 business days" },
];
const DISC = 0.12;
const BUNDLE_PRICE = (t) => Math.round((t.listing + t.pricing) * (1 - DISC));
const BUNDLE_SAVE  = (t) => Math.round((t.listing + t.pricing) - BUNDLE_PRICE(t));
const fmt = (n) => "AED " + Math.round(n).toLocaleString();

// ── REPLACE THIS WITH YOUR TYPEFORM LINK ────────────────────────────
const TYPEFORM_URL = "https://form.typeform.com/to/fv8ZK2kU";
// ── REPLACE THIS WITH YOUR WEB3FORMS ACCESS KEY ─────────────────────
const WEB3FORMS_KEY = "2f450601-256b-470b-b015-3147a032ddb8";
// ────────────────────────────────────────────────────────────────────

const SVC_OPTIONS = [
  { key: "listing", label: "Listing only" },
  { key: "pricing", label: "Pricing only" },
  { key: "bundle",  label: "Bundle — 12% off" },
];

const PLATFORMS = [
  { name: "Airbnb",           soon: false },
  { name: "Booking.com",      soon: false },
  { name: "Expedia",          soon: true  },
  { name: "VRBO",             soon: true  },
  { name: "Local platforms",  soon: true  },
];

export default function ListingPricing() {
  const [svc, setSvc]         = useState("listing");
  const [selIdx, setSelIdx]   = useState(null);
  const [step, setStep]       = useState("tier"); // "tier" | "form" | "success"
  const [loading, setLoading] = useState(false);
  const [form, setForm]       = useState({ name: "", email: "", phone: "", units: "" });
  const [error, setError]     = useState("");

  const getPrice = (t) => svc === "listing" ? t.listing : svc === "pricing" ? t.pricing : BUNDLE_PRICE(t);
  const getDelivery = (t) => svc === "listing" ? t.ld : svc === "pricing" ? t.pd : t.bd;
  const svcName = () => svc === "listing" ? "Listing Optimisation" : svc === "pricing" ? "Pricing Optimisation" : "Listing + Pricing Bundle";

  const selectedTier = selIdx !== null ? TIERS[selIdx] : null;

  const handleSvcChange = (key) => { setSvc(key); setSelIdx(null); };
  const handleTierSelect = (i) => setSelIdx(i);

  const handleFormChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async () => {
    const { name, email, phone, units } = form;
    if (!name || !email || !phone || !units) { setError("Please fill in all fields."); return; }
    if (!/\S+@\S+\.\S+/.test(email)) { setError("Please enter a valid email address."); return; }
    setError("");
    setLoading(true);
    const t = selectedTier;
    const msg = `NEW BOOKING — SLS Listing & Pricing Optimisation
══════════════════════════════
CLIENT
Name:     ${name}
Email:    ${email}
WhatsApp: ${phone}
Units:    ${units}

SERVICE
Service:  ${svcName()}
Tier:     ${t.u} units
Price:    ${fmt(getPrice(t))}
Delivery: ${getDelivery(t)}
${svc !== "listing" ? "Note: Platform fees to be confirmed separately.\n" : ""}
══════════════════════════════
NEXT: Send payment link. Typeform auto-sent to client.`;

    try {
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          access_key: WEB3FORMS_KEY,
          to: "stephanieluxesolutions@gmail.com",
          subject: `New Booking — ${svcName()} · ${t.u} units · ${fmt(getPrice(t))}`,
          message: msg,
          from_name: name,
          reply_to: email,
        }),
      });
      const data = await res.json();
      if (data.success) {
        setStep("success");
      } else throw new Error();
    } catch {
      setError("Something went wrong. Please email us at stephanieluxesolutions@gmail.com");
    } finally {
      setLoading(false);
    }
  };

  const typeformLink = selectedTier
    ? `${TYPEFORM_URL}?name=${encodeURIComponent(form.name)}&email=${encodeURIComponent(form.email)}&service=${encodeURIComponent(svcName())}&tier=${encodeURIComponent(selectedTier.u)}`
    : TYPEFORM_URL;

  return (
    <>
      {/* ── GOOGLE FONTS ── */}
      <link
        href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;1,400&family=DM+Sans:wght@300;400;500&display=swap"
        rel="stylesheet"
      />

      <style>{`
        .lp-page {
          min-height: 100vh;
          background: #F5F0E8;
          font-family: 'DM Sans', sans-serif;
          color: #2C1F14;
        }

        /* ── NAV ── */
        .lp-nav {
          background: #2C1F14;
          padding: 0 2rem;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: sticky;
          top: 0;
          z-index: 50;
        }
        .lp-nav-logo {
          font-family: 'Cormorant Garamond', serif;
          font-size: 17px;
          font-weight: 500;
          color: #F5F0E8;
          text-decoration: none;
          letter-spacing: 0.02em;
        }
        .lp-nav-back {
          font-size: 11px;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          color: #C4A882;
          text-decoration: none;
          display: flex;
          align-items: center;
          gap: 6px;
          transition: opacity 0.15s;
        }
        .lp-nav-back:hover { opacity: 0.7; }

        /* ── HERO ── */
        .lp-hero {
          background: #2C1F14;
          padding: 3.5rem 2rem 3rem;
          text-align: center;
        }
        .lp-hero-eyebrow {
          font-size: 10px;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          color: #C4A882;
          margin-bottom: 12px;
        }
        .lp-hero-title {
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(32px, 5vw, 48px);
          font-weight: 500;
          color: #F5F0E8;
          line-height: 1.1;
          margin-bottom: 14px;
        }
        .lp-hero-sub {
          font-size: 14px;
          color: rgba(245,240,232,0.55);
          line-height: 1.65;
          max-width: 480px;
          margin: 0 auto 22px;
        }
        .lp-platform-row {
          display: flex;
          gap: 6px;
          flex-wrap: wrap;
          justify-content: center;
        }
        .lp-ptag {
          font-size: 9px;
          font-weight: 500;
          letter-spacing: 0.07em;
          text-transform: uppercase;
          padding: 4px 11px;
          border-radius: 2px;
          border: 0.5px solid #C4A882;
          color: #C4A882;
        }
        .lp-ptag.soon {
          border-color: rgba(196,168,130,0.28);
          color: rgba(196,168,130,0.38);
        }

        /* ── MAIN CONTENT ── */
        .lp-content {
          max-width: 700px;
          margin: 0 auto;
          padding: 2.5rem 1.5rem 4rem;
        }

        /* ── SERVICE TOGGLE ── */
        .lp-svc-toggle {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          border: 0.5px solid rgba(196,168,130,0.5);
          border-radius: 4px;
          overflow: hidden;
          margin-bottom: 1.5rem;
        }
        .lp-svc-btn {
          padding: 11px 8px;
          font-family: 'DM Sans', sans-serif;
          font-size: 12px;
          font-weight: 400;
          background: transparent;
          color: #6B5744;
          border: none;
          border-right: 0.5px solid rgba(196,168,130,0.5);
          cursor: pointer;
          transition: all 0.15s;
          text-align: center;
          white-space: nowrap;
        }
        .lp-svc-btn:last-child { border-right: none; }
        .lp-svc-btn.on {
          background: #2C1F14;
          color: #F5F0E8;
          font-weight: 500;
        }

        /* ── SECTION LABEL ── */
        .lp-section-lbl {
          font-size: 10px;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          color: #6B5744;
          opacity: 0.65;
          margin-bottom: 10px;
        }

        /* ── TIER GRID ── */
        .lp-tier-grid {
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          gap: 8px;
          margin-bottom: 1.5rem;
        }
        @media (max-width: 500px) {
          .lp-tier-grid { grid-template-columns: repeat(3, 1fr); }
        }
        .lp-tier-btn {
          background: white;
          border: 0.5px solid rgba(196,168,130,0.5);
          border-radius: 4px;
          padding: 12px 6px 10px;
          cursor: pointer;
          text-align: center;
          position: relative;
          transition: all 0.15s;
          font-family: 'DM Sans', sans-serif;
        }
        .lp-tier-btn:hover { border-color: #C4A882; }
        .lp-tier-btn.sel {
          border: 1.5px solid #C4A882;
          background: #EDE5D8;
        }
        .lp-tier-btn.sel::after {
          content: '';
          position: absolute;
          top: -1px; right: -1px;
          width: 8px; height: 8px;
          background: #C4A882;
          border-radius: 0 3px 0 3px;
        }
        .lp-t-units {
          display: block;
          font-size: 10px;
          font-weight: 500;
          color: #2C1F14;
          margin-bottom: 4px;
          line-height: 1.3;
        }
        .lp-t-price {
          display: block;
          font-family: 'Cormorant Garamond', serif;
          font-size: 14px;
          font-weight: 600;
          color: #2C1F14;
        }
        .lp-t-del {
          display: block;
          font-size: 8px;
          color: #6B5744;
          margin-top: 4px;
          line-height: 1.3;
          opacity: 0.7;
        }
        .lp-pop-badge {
          position: absolute;
          top: -10px;
          left: 50%;
          transform: translateX(-50%);
          background: #C4A882;
          color: #2C1F14;
          font-size: 7px;
          font-weight: 500;
          letter-spacing: 0.05em;
          padding: 2px 6px;
          border-radius: 2px;
          white-space: nowrap;
          text-transform: uppercase;
        }

        /* ── PRICE SUMMARY BOX ── */
        .lp-price-box {
          background: #2C1F14;
          border-radius: 6px;
          padding: 16px 18px;
          margin-bottom: 1rem;
        }
        .lp-pb-row {
          display: flex;
          justify-content: space-between;
          align-items: baseline;
          margin-bottom: 6px;
        }
        .lp-pb-lbl { font-size: 11px; color: rgba(245,240,232,0.5); }
        .lp-pb-val {
          font-family: 'Cormorant Garamond', serif;
          font-size: 20px;
          color: #C4A882;
          font-weight: 500;
        }
        .lp-pb-strike {
          font-size: 13px;
          text-decoration: line-through;
          color: rgba(245,240,232,0.25);
          font-family: 'Cormorant Garamond', serif;
        }
        .lp-pb-save {
          display: flex;
          justify-content: space-between;
          font-size: 11px;
          color: #d4bc9e;
          border-top: 0.5px solid rgba(196,168,130,0.18);
          padding-top: 8px;
          margin-top: 8px;
        }
        .lp-pb-meta {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 11px;
          color: rgba(245,240,232,0.38);
          margin-top: 7px;
        }

        /* ── BOOK BTN ── */
        .lp-book-btn {
          width: 100%;
          background: #C4A882;
          color: #2C1F14;
          font-family: 'DM Sans', sans-serif;
          font-size: 13px;
          font-weight: 500;
          letter-spacing: 0.06em;
          text-transform: uppercase;
          border: none;
          border-radius: 4px;
          padding: 14px;
          cursor: pointer;
          transition: background 0.18s;
          margin-bottom: 10px;
        }
        .lp-book-btn:hover { background: #d4bc9e; }
        .lp-after-note {
          font-size: 11px;
          color: #6B5744;
          text-align: center;
          line-height: 1.6;
          opacity: 0.75;
        }

        /* ── FORM STEP ── */
        .lp-booking-summary {
          background: #EDE5D8;
          border-radius: 4px;
          padding: 12px 14px;
          margin-bottom: 1.5rem;
          font-size: 12px;
          color: #6B5744;
          border-left: 2px solid #C4A882;
          line-height: 1.7;
        }
        .lp-booking-summary strong { color: #2C1F14; font-weight: 500; }
        .lp-field-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 12px;
          margin-bottom: 12px;
        }
        @media (max-width: 480px) { .lp-field-row { grid-template-columns: 1fr; } }
        .lp-flbl {
          display: block;
          font-size: 10px;
          font-weight: 500;
          letter-spacing: 0.07em;
          text-transform: uppercase;
          color: #6B5744;
          margin-bottom: 5px;
        }
        .lp-finput {
          width: 100%;
          padding: 11px 13px;
          background: white;
          border: 0.5px solid rgba(196,168,130,0.5);
          border-radius: 4px;
          font-family: 'DM Sans', sans-serif;
          font-size: 13px;
          color: #2C1F14;
          outline: none;
          transition: border-color 0.15s;
        }
        .lp-finput:focus { border-color: #C4A882; }
        .lp-privacy-note {
          background: #EDE5D8;
          border-radius: 4px;
          padding: 11px 13px;
          font-size: 11px;
          color: #6B5744;
          line-height: 1.65;
          margin-bottom: 1.25rem;
          border-left: 2px solid #C4A882;
        }
        .lp-submit-btn {
          width: 100%;
          background: #2C1F14;
          color: #F5F0E8;
          font-family: 'DM Sans', sans-serif;
          font-size: 13px;
          font-weight: 500;
          letter-spacing: 0.06em;
          text-transform: uppercase;
          border: none;
          border-radius: 4px;
          padding: 14px;
          cursor: pointer;
          transition: background 0.18s;
        }
        .lp-submit-btn:hover { background: #6B5744; }
        .lp-submit-btn:disabled { opacity: 0.55; cursor: not-allowed; }
        .lp-back-btn {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 11px;
          color: #6B5744;
          background: none;
          border: none;
          cursor: pointer;
          padding: 0;
          margin-bottom: 1.5rem;
          opacity: 0.7;
          transition: opacity 0.15s;
          font-family: 'DM Sans', sans-serif;
        }
        .lp-back-btn:hover { opacity: 1; }
        .lp-error {
          font-size: 12px;
          color: #c0392b;
          margin-top: 8px;
          text-align: center;
        }

        /* ── SUCCESS ── */
        .lp-success {
          text-align: center;
          padding: 3rem 1rem;
        }
        .lp-success-icon {
          font-size: 44px;
          color: #C4A882;
          margin-bottom: 1rem;
        }
        .lp-success-title {
          font-family: 'Cormorant Garamond', serif;
          font-size: 28px;
          font-weight: 500;
          color: #2C1F14;
          margin-bottom: 12px;
        }
        .lp-success-body {
          font-size: 13px;
          color: #6B5744;
          line-height: 1.75;
          max-width: 400px;
          margin: 0 auto 1.5rem;
        }
        .lp-typeform-btn {
          display: inline-block;
          background: #C4A882;
          color: #2C1F14;
          font-family: 'DM Sans', sans-serif;
          font-size: 12px;
          font-weight: 500;
          letter-spacing: 0.06em;
          text-transform: uppercase;
          padding: 12px 24px;
          border-radius: 4px;
          text-decoration: none;
          transition: background 0.18s;
        }
        .lp-typeform-btn:hover { background: #d4bc9e; }
        .lp-success-note {
          font-size: 11px;
          color: #6B5744;
          opacity: 0.6;
          margin-top: 12px;
        }

        /* ── ENTERPRISE NOTE ── */
        .lp-enterprise {
          background: #EDE5D8;
          border-radius: 6px;
          padding: 14px 16px;
          font-size: 12px;
          color: #6B5744;
          line-height: 1.6;
          margin-top: 1.5rem;
          border-left: 3px solid #C4A882;
        }
        .lp-enterprise a { color: #C4A882; text-decoration: none; }

        /* ── STEP DIVIDER ── */
        .lp-step-title {
          font-family: 'Cormorant Garamond', serif;
          font-size: 22px;
          font-weight: 500;
          color: #2C1F14;
          margin-bottom: 6px;
        }
        .lp-step-sub {
          font-size: 12px;
          color: #6B5744;
          margin-bottom: 1.5rem;
          line-height: 1.5;
        }
      `}</style>

      <div className="lp-page">

        {/* ── NAV ── */}
        <nav className="lp-nav">
          <Link to="/" className="lp-nav-logo">Stephanies Luxe Solutions</Link>
          <Link to="/" className="lp-nav-back">← Back to home</Link>
        </nav>

        {/* ── HERO ── */}
        <div className="lp-hero">
          <p className="lp-hero-eyebrow">SLS — Premium STR Consultancy · Dubai & UAE</p>
          <h1 className="lp-hero-title">Listing & Pricing<br />Optimisation</h1>
          <p className="lp-hero-sub">
            Professional one-time setup across leading short-term rental platforms —
            built to attract more guests and earn more per booking, every night of the year.
          </p>
          <div className="lp-platform-row">
            {PLATFORMS.map((p) => (
              <span key={p.name} className={`lp-ptag${p.soon ? " soon" : ""}`}>
                {p.name}{p.soon ? " — coming soon" : ""}
              </span>
            ))}
          </div>
        </div>

        {/* ── MAIN CONTENT ── */}
        <div className="lp-content">

          {/* ══ STEP: TIER SELECTION ══ */}
          {step === "tier" && (
            <>
              <h2 className="lp-step-title">Choose your service</h2>
              <p className="lp-step-sub">Select what you need, then pick your portfolio size to see your price.</p>

              {/* Service toggle */}
              <div className="lp-svc-toggle">
                {SVC_OPTIONS.map((o) => (
                  <button
                    key={o.key}
                    className={`lp-svc-btn${svc === o.key ? " on" : ""}`}
                    onClick={() => handleSvcChange(o.key)}
                  >
                    {o.label}
                  </button>
                ))}
              </div>

              {/* Tier grid */}
              <p className="lp-section-lbl">Portfolio size</p>
              <div className="lp-tier-grid">
                {TIERS.map((t, i) => (
                  <div
                    key={t.u}
                    className={`lp-tier-btn${selIdx === i ? " sel" : ""}`}
                    onClick={() => handleTierSelect(i)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => e.key === "Enter" && handleTierSelect(i)}
                    aria-pressed={selIdx === i}
                  >
                    {t.popular && <span className="lp-pop-badge">Popular</span>}
                    <span className="lp-t-units">{t.u}<br />units</span>
                    <span className="lp-t-price">{fmt(getPrice(t))}</span>
                    <span className="lp-t-del">{getDelivery(t)}</span>
                  </div>
                ))}
              </div>

              {/* Price summary */}
              {selectedTier && (
                <div className="lp-price-box">
                  <div className="lp-pb-row">
                    <span className="lp-pb-lbl">
                      {svc === "bundle" ? "Bundle setup price" : "One-time setup"}
                    </span>
                    <span className="lp-pb-val">{fmt(getPrice(selectedTier))}</span>
                  </div>
                  {svc === "bundle" && (
                    <>
                      <div className="lp-pb-row">
                        <span className="lp-pb-lbl">Without bundle</span>
                        <span className="lp-pb-strike">{fmt(selectedTier.listing + selectedTier.pricing)}</span>
                      </div>
                      <div className="lp-pb-save">
                        <span>You save</span>
                        <span>{fmt(BUNDLE_SAVE(selectedTier))}</span>
                      </div>
                    </>
                  )}
                  <div className="lp-pb-meta">
                    <span>🕐</span>
                    <span>{getDelivery(selectedTier)}</span>
                  </div>
                  {svc !== "listing" && (
                    <div className="lp-pb-meta">
                      <span>ℹ</span>
                      <span>Platform fees charged separately at cost</span>
                    </div>
                  )}
                </div>
              )}

              {selectedTier && (
                <>
                  <button className="lp-book-btn" onClick={() => setStep("form")}>
                    Book now — confirm your slot
                  </button>
                  <p className="lp-after-note">
                    After booking you'll receive a Typeform to share listing details.<br />
                    Payment link follows. Platform logins only requested once payment is confirmed.
                  </p>
                </>
              )}

              <div className="lp-enterprise">
                <strong>50+ units?</strong> Published rates above apply. For large or multi-site portfolios,
                enterprise pricing is available —{" "}
                <a href="mailto:stephanieluxesolutions@gmail.com">contact us</a> for a tailored proposal.
              </div>
            </>
          )}

          {/* ══ STEP: BOOKING FORM ══ */}
          {step === "form" && selectedTier && (
            <>
              <button className="lp-back-btn" onClick={() => setStep("tier")}>
                ← Back
              </button>
              <h2 className="lp-step-title">Confirm your booking</h2>
              <p className="lp-step-sub">Just a few details and we'll take it from there.</p>

              <div className="lp-booking-summary">
                <strong>Service:</strong> {svcName()}<br />
                <strong>Tier:</strong> {selectedTier.label}<br />
                <strong>Price:</strong> {fmt(getPrice(selectedTier))}<br />
                <strong>Delivery:</strong> {getDelivery(selectedTier)}
                {svc !== "listing" && <><br /><strong>Note:</strong> Platform fees charged separately at cost</>}
              </div>

              <div className="lp-field-row">
                <div>
                  <label className="lp-flbl" htmlFor="f-name">Full name</label>
                  <input className="lp-finput" id="f-name" name="name" type="text" placeholder="Your name" value={form.name} onChange={handleFormChange} />
                </div>
                <div>
                  <label className="lp-flbl" htmlFor="f-email">Email address</label>
                  <input className="lp-finput" id="f-email" name="email" type="email" placeholder="you@email.com" value={form.email} onChange={handleFormChange} />
                </div>
              </div>
              <div className="lp-field-row">
                <div>
                  <label className="lp-flbl" htmlFor="f-phone">WhatsApp / Phone</label>
                  <input className="lp-finput" id="f-phone" name="phone" type="tel" placeholder="+971 xx xxx xxxx" value={form.phone} onChange={handleFormChange} />
                </div>
                <div>
                  <label className="lp-flbl" htmlFor="f-units">Number of units</label>
                  <input className="lp-finput" id="f-units" name="units" type="number" placeholder="e.g. 4" min="1" value={form.units} onChange={handleFormChange} />
                </div>
              </div>

              <div className="lp-privacy-note">
                After submitting, you'll receive a Typeform to share your listing details and we'll send your payment link.
                Platform logins are only requested once payment is confirmed and work is ready to begin.
              </div>

              {error && <p className="lp-error">{error}</p>}

              <button className="lp-submit-btn" onClick={handleSubmit} disabled={loading}>
                {loading ? "Sending..." : "Send booking request"}
              </button>
            </>
          )}

          {/* ══ STEP: SUCCESS ══ */}
          {step === "success" && (
            <div className="lp-success">
              <div className="lp-success-icon">✓</div>
              <h2 className="lp-success-title">Booking request received</h2>
              <p className="lp-success-body">
                Thank you — Stephanie will be in touch within 24 hours with your payment link.<br /><br />
                In the meantime, please complete our listing details form so we can hit the ground running.
              </p>
              <a className="lp-typeform-btn" href={typeformLink} target="_blank" rel="noreferrer">
                Complete listing details form →
              </a>
              <p className="lp-success-note">Also check your inbox for a confirmation from SLS.</p>
            </div>
          )}

        </div>
      </div>
    </>
  );
}
